import { render, staticRenderFns } from "./user-panel.vue?vue&type=template&id=c13b564e"
import script from "./user-panel.vue?vue&type=script&lang=js"
export * from "./user-panel.vue?vue&type=script&lang=js"
import style0 from "./user-panel.vue?vue&type=style&index=0&id=c13b564e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports